/**
 * 导航提供者
 * 提供导航服务的上下文
 */

import React, { createContext, useContext, useMemo, ReactNode, useTransition } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationService } from './navigationService.js';

// 创建导航上下文
const NavigationContext = createContext<NavigationService | null>(null);

export interface NavigationProviderProps {
  children: ReactNode;
}

/**
 * 导航服务提供者组件
 */
export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
  const navigate = useNavigate();
  const [, startTransition] = useTransition();

  // 创建导航服务实例
  const navigationService = useMemo(() => {
    // 将 navigate 和 startTransition 传递给服务
    return new NavigationService(navigate, startTransition);
  }, [navigate, startTransition]);

  return (
    <NavigationContext.Provider value={navigationService}>{children}</NavigationContext.Provider>
  );
};

/**
 * 使用导航服务的自定义Hook
 */
export function useNavigation(): NavigationService {
  const context = useContext(NavigationContext);

  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }

  return context;
}
